import { render, staticRenderFns } from "./VerificationPrompt.vue?vue&type=template&id=5e57ae0d&"
import script from "./VerificationPrompt.vue?vue&type=script&lang=js&"
export * from "./VerificationPrompt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports